// PrimeVue/Lara presets, downloaded from https://tailwind.primevue.org/builder/ and modified for Goalbook

import global from './global.js'
import button from './button/index.js'
import calendar from './calendar/index.js'
import checkbox from './checkbox/index.js'
import datatable from './datatable/index.js'
import dialog from './dialog/index.js'
import dropdown from './dropdown/index.js'
import inlinemessage from './inlinemessage/index.js'
import inputtext from './inputtext/index.js'
import menu from './menu/index.js'
import menubar from './menubar/index.js'
import overlaypanel from './overlaypanel/index.js'
import progressspinner from './progressspinner/index.js'
import radiobutton from './radiobutton/index.js'
import tabview from './tabview/index.js'

export default {
  global,
  button,
  calendar,
  checkbox,
  datatable,
  dialog,
  dropdown,
  inlinemessage,
  inputtext,
  menu,
  menubar,
  overlaypanel,
  progressspinner,
  radiobutton,
  tabview
}
